import { resetState } from 'redux/actions';
import { clearDefaults } from './';

export const resetCache = async () => {
  const { store } = await import('App');
  clearDefaults();
  store.dispatch(resetState());
};
